<template>

  <div class="LoginModulo">
    <!--<h1><span>{{$t('login.title1')}}</span> {{$t('login.title1')}}</h1>-->
    <h1 v-html="$t('login.title')"></h1>
    <el-form :model="loginForm" :rules="rules" ref="loginForm" class="" :show-message=false>
      <el-form-item prop="username" :class="{'is-error' : isErrorLogin}">
        <el-input v-model="loginForm.username" v-bind:placeholder="$t('login.username')" @change="clearError"
                  v-on:keyup.enter.native="submitForm('loginForm')" name="username" />
      </el-form-item>
      <el-form-item prop="password" :class="{'is-error' : isErrorLogin}">
        <el-input v-model="loginForm.password" v-bind:placeholder="$t('login.password')" type="password"
                  @change="clearError"
                  v-on:keyup.enter.native="submitForm('loginForm')" name="password" />
      </el-form-item>
      <div class="errorLogin">
              <span v-if="isErrorLogin">
                {{$t('login.msg.errLogin')}}
              </span>
      </div>
      <div class="recCred  col-xs-24"><span @click="link('Recovery')">{{$t('login.btn.recPassword')}}</span></div>
        <el-form-item>
          <el-button  v-on:keyup.enter="submitForm('loginForm')" @click="submitForm('loginForm')">
            {{$t('login.btn.enter')}}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="registrati"  @click="link('Registrazione')">{{$t('login.btn.reg')}} </el-button>
        </el-form-item>
    </el-form>


  </div>
</template>

<script>
  export default {
    name: 'Login',
    props: ['language'],
    data () {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        rules: {
          username: [
            {required: true, trigger: 'blur'}
          ],
          password: [
            {required: true, trigger: 'blur'}
          ]
        },
        loginVisible: true,
        isErrorLogin: false
      }
    },
    i18n: {
      messages: {
        it_IT: {
          login: {
            title: '<span>Area</span> Fornitori',
            username: 'Utente',
            password: 'Password',

            btn: {
              enter: 'Accedi',
              reg: 'Registrati',
              recPassword: 'Recupera Utente e/o Password'
            },
            msg: {
              errLogin: 'Username o password errati'
            },
            headerValidazioneMail: 'Validazione indirizzo email',
            validateMailTxt: 'Per accedere al portale è necessario validare l\'indirizzo email. Puoi saltare questo passaggio un numero limitato di volte.<br>Premi INVIA per ricevere l\'email con il link per la verifica.',
            invia: 'Invia',
            accedi: 'Accedi',
            annulla: 'Annulla',
            noMailValidation: 'Non hai validato l\'indirizzo email.<br>Per continuare è necessario effettuare la validazione.<br>Verrà inviata un\'email all\'indirizzo associato al tuo account con un link per la verifica.',
            loginDisponibili: 'Accessi ancora disponibili',
            validateMailObblig: 'Hai superato il limite di accessi in assenza della validazione dell\'indirizzo email.<br>Per continuare è necessario effettuare la validazione.<br>Verrà inviata un\'email all\'indirizzo associato al tuo account con un link per la verifica.'
          }
        },
        en_GB: {
          login: {
            title: 'Suppliers\' <span>Area</span>',
            username: 'User',
            password: 'Password',
            btn: {
              enter: 'Enter',
              reg: 'Register Now',
              recPassword: 'Recover User or Password'
            },
            msg: {
              errLogin: 'Wrong username or password'
            },
            headerValidazioneMail: 'Email Address Validation',
            validateMailTxt: 'To access the portal, you must validate your email address. You can skip this step a limited number of times.<br>Press SEND to receive an email with the verification link.',
            invia: 'Send',
            accedi: 'Login',
            annulla: 'Cancel',
            noMailValidation: 'You have not validated your email address.<br>To continue, you must complete the validation.<br>An email with a verification link will be sent to the address associated with your account.',
            loginDisponibili: 'Remaining logins',
            validateMailObblig: 'You have exceeded the number of logins allowed without validating your email address.<br>To continue, you must complete the validation.<br>An email with a verification link will be sent to the address associated with your account.'
          }
        },
        es_ES: {
          login: {
            title: '<span>Área</span> Proveedores',
            username: 'Usuario',
            password: 'Contraseña',
            btn: {
              enter: 'Acceso',
              reg: 'Registro',
              recPassword: 'Recuperar usuario o contraseña'
            },
            msg: {
              errLogin: 'Nombre de usuario o contraseña incorrectos'
            },
            headerValidazioneMail: 'Validación de dirección de correo electrónico',
            validateMailTxt: 'Para acceder al portal, debes validar tu dirección de correo electrónico. Puedes omitir este paso un número limitado de veces.<br>Presiona ENVIAR para recibir un correo con el enlace de verificación.',
            invia: 'Enviar',
            accedi: 'Acceder',
            annulla: 'Cancelar',
            noMailValidation: 'No has validado tu dirección de correo electrónico.<br>Para continuar, debes completar la validación.<br>Se enviará un correo electrónico a la dirección asociada a tu cuenta con un enlace de verificación.',
            loginDisponibili: 'Accesos restantes',
            validateMailObblig: 'Has superado el límite de accesos sin validar tu dirección de correo electrónico.<br>Para continuar, debes completar la validación.<br>Se enviará un correo electrónico a la dirección asociada a tu cuenta con un enlace de verificación.'
          }
        },
        fr_FR: {
          login: {
            title: '<span>Session</span> Fournisseurs',
            username: 'Utilisateur',
            password: 'Mot de passe',
            btn: {
              enter: 'Accès',
              reg: 'Inscription',
              recPassword: 'Récupérer utilisateur ou mot de passe'
            },
            msg: {
              errLogin: 'Mauvais nom d\'utilisateur ou mot de passe'
            },
            headerValidazioneMail: 'Validation de l\'adresse email',
            validateMailTxt: 'Pour accéder au portail, vous devez valider votre adresse email. Vous pouvez ignorer cette étape un nombre limité de fois.<br>Appuyez sur ENVOYER pour recevoir un email contenant le lien de vérification.',
            invia: 'Envoyer',
            accedi: 'Accéder',
            annulla: 'Annuler',
            noMailValidation: 'Vous n\'avez pas validé votre adresse email.<br>Pour continuer, vous devez effectuer la validation.<br>Un email contenant un lien de vérification sera envoyé à l\'adresse associée à votre compte.',
            loginDisponibili: 'Connexions restantes',
            validateMailObblig: 'Vous avez dépassé le nombre de connexions autorisées sans validation de l\'adresse email.<br>Pour continuer, vous devez effectuer la validation.<br>Un email contenant un lien de vérification sera envoyé à l\'adresse associée à votre compte.'
          }
        },
        de_DE: {
          login: {
            title: '<span>Bereich</span> Lieferanten',
            username: 'Benutzer',
            password: 'Passwort',
            btn: {
              enter: 'Zugang',
              reg: 'Registrieren',
              recPassword: 'Benutzer oder Passwort wiederherstellen'
            },
            msg: {
              errLogin: 'Falscher Benutzername oder Passwort'
            },
            headerValidazioneMail: 'E-Mail-Adresse bestätigen',
            validateMailTxt: 'Um auf das Portal zuzugreifen, müssen Sie Ihre E-Mail-Adresse bestätigen. Sie können diesen Schritt eine begrenzte Anzahl von Malen überspringen.<br>Klicken Sie auf SENDEN, um eine E-Mail mit dem Bestätigungslink zu erhalten.',
            invia: 'Senden',
            accedi: 'Anmelden',
            annulla: 'Abbrechen',
            noMailValidation: 'Sie haben Ihre E-Mail-Adresse nicht bestätigt.<br>Um fortzufahren, müssen Sie die Validierung durchführen.<br>Eine E-Mail mit einem Bestätigungslink wird an die mit Ihrem Konto verknüpfte Adresse gesendet.',
            loginDisponibili: 'Verbleibende Anmeldungen',
            validateMailObblig: 'Sie haben das Limit für Anmeldungen ohne E-Mail-Bestätigung überschritten.<br>Um fortzufahren, müssen Sie die Validierung durchführen.<br>Eine E-Mail mit einem Bestätigungslink wird an die mit Ihrem Konto verknüpfte Adresse gesendet.'
          }
        }
      }
    },
    beforeMount: function () {
      if (sessionStorage.getItem('token') !== null) {
        this.checkUserLogged()
      }
    },
    methods: {
      submitForm: function (formName) {
        this.clearError()
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let obj = {
              username: this.loginForm.username,
              pwd: this.loginForm.password,
              codLang: this.language
            }
            this.$http.post('noauth/login', obj)
              .then(response => {
                if (response.status === 200) {
                  if (response.body.rc === 0) {
                    sessionStorage.setItem('token', response.body.wsToken)
                    sessionStorage.setItem('codLang', response.body.preferredLanguage)

                    // PATCH Amministrazione --> Aggiunta nuova area (ACCSTA)
                    if (localStorage.hasOwnProperty('amministrazione')) {
                      let amministrazione = JSON.parse(localStorage.getItem('amministrazione'))
                      if (!amministrazione.hasOwnProperty('ACCSTA')) {
                        amministrazione.ACCSTA = {
                          1: '',
                          2: '',
                          3: '',
                          4: '',
                          5: ''
                        }
                      }
                      localStorage.setItem('amministrazione', JSON.stringify(amministrazione))
                    }
                    // FINE PACH

                    if (response.body.loginDisp) {
                      let message = '<span>' + this.$t('login.validateMailTxt') + '<br><br>' + this.$t('login.loginDisponibili') + ': ' + response.body.loginDisp + '</span>'
                      this.$confirm(message, this.$t('login.headerValidazioneMail').toUpperCase(), {
                        confirmButtonText: this.$t('login.invia').toUpperCase(),
                        cancelButtonText: this.$t('login.accedi').toUpperCase(),
                        type: 'warning',
                        customClass: 'custom-confirm',
                        showClose: false,
                        showCancelButton: true,
                        closeOnClickModal: false,
                        dangerouslyUseHTMLString: true
                      })
                        .then(() => {
                          this.$http.post('noauth/verificamail', {username: this.loginForm.username, pwd: this.loginForm.password, codLang: response.body.preferredLanguage})
                            .then(rs => {
                              if (rs.body.rc === 0) {
                                this.$message({
                                  showClose: true,
                                  message: rs.body.msg[0].idWeb ? this.$t(rs.body.msg[0].idWeb) : rs.body.msg[0].msgTxt,
                                  type: 'success',
                                  duration: process.env.duration
                                })
                              } else {
                                this.$message({
                                  showClose: true,
                                  message: rs.body.msg[0].idWeb ? this.$t(rs.body.msg[0].idWeb) : rs.body.msg[0].msgTxt,
                                  type: 'error',
                                  duration: process.env.duration
                                })

                                this.$router.push({name: 'IndexPortale'})
                              }
                            })
                            .catch((err) => {
                              this.$message({
                                showClose: true,
                                message: err.body.msg[0].idWeb ? this.$t(err.body.msg[0].idWeb) : err.body.msg[0].msgTxt,
                                type: 'error',
                                duration: process.env.duration
                              })

                              this.$router.push({name: 'IndexPortale'})
                            })
                        })
                        .catch(() => {
                          this.$router.push({name: 'IndexPortale'})
                        })
                    } else {
                      this.$router.push({name: 'IndexPortale'})
                    }
                  } else {
                    this.$message({
                      showClose: true,
                      message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
                      type: 'error',
                      duration: process.env.duration
                    })
                  }
                }
              }, response => {
                if (response.body.attrib && (response.body.attrib.loginDisp === '0' || response.body.attrib.loginDisp === '90')) {
                  this.$confirm(
                    response.body.attrib.loginDisp === '0' ? this.$t('login.validateMailObblig') : this.$t('login.noMailValidation'),
                    this.$t('login.headerValidazioneMail').toUpperCase(),
                    {
                      confirmButtonText: this.$t('login.invia').toUpperCase(),
                      cancelButtonText: this.$t('login.annulla').toUpperCase(),
                      type: 'warning',
                      customClass: 'custom-confirm',
                      showCancelButton: true,
                      showClose: false,
                      closeOnClickModal: false,
                      dangerouslyUseHTMLString: true
                    }
                  )
                    .then(() => {
                      this.$http.post('noauth/verificamail', {username: this.loginForm.username, pwd: this.loginForm.password, codLang: response.body.attrib.codLang})
                        .then(rs => {
                          if (rs.body.rc === 0) {
                            this.$message({
                              showClose: true,
                              message: rs.body.msg[0].idWeb ? this.$t(rs.body.msg[0].idWeb) : rs.body.msg[0].msgTxt,
                              type: 'success',
                              duration: process.env.duration
                            })
                          } else {
                            this.$message({
                              showClose: true,
                              message: rs.body.msg[0].idWeb ? this.$t(rs.body.msg[0].idWeb) : rs.body.msg[0].msgTxt,
                              type: 'error',
                              duration: process.env.duration
                            })
                          }
                        })
                        .catch((err) => {
                          this.$message({
                            showClose: true,
                            message: err.body.msg[0].idWeb ? this.$t(err.body.msg[0].idWeb) : err.body.msg[0].msgTxt,
                            type: 'error',
                            duration: process.env.duration
                          })
                        })
                    })
                    .catch(() => {
                      //
                    })
                } else {
                  console.log('error login!!')
                  this.isErrorLogin = true
                }
              })
          } else {
            this.isErrorLogin = true
            return false
          }
        })
      },
      clearError: function () {
        this.isErrorLogin = false
      },
      checkUserLogged: function () {
        this.$http.get('portale/checkuserlogged')
          .then(response => {
            if (response.status === 200) {
              this.$router.push({name: 'IndexPortale'})
            }
          }, response => {
            console.log('User not Logged')
          })
      },
      link: function (value) {
        this.$emit('link', value)
      },
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .LoginModulo {
    height: 500px;
    padding: 15px 50px;
    h1 {
      text-align: left;
      .set-font(@weight: 900,@size: 42px, @color: #fff);
      margin-bottom: 80px;
      span {
        .set-font(@weight: 300,@size: 42px, @color: #fff);
      }
    }
    .el-form-item {
      text-align: center;
      margin-bottom: 0;
      &.is-error {
        .el-input__inner {
          outline: #f56c6c solid 1px;
          outline: rgba(255, 0, 0, 0.9) solid 1px;
          outline-offset: 0px;
        }
      }
      .el-input {
        width: 100%;
        .el-input__inner {
          .set-font(@weight: 300,@size: 16px, @color: #000);
          display: block;
          margin: 10px auto;
          padding: 10px;
          width: 300px;
          border: 0;
          background-color: #fff;
          //background-color: rgba(255, 255, 255, .7);
          border: none;
          border-radius: 0px;
          line-height: 0;
          &:focus {
            outline: #000 solid 1px;
            outline: rgba(0, 0, 0, .4) solid 1px;
            outline-offset: 0px;
          }
        }
        ::placeholder {
          color: #a2a2a2;
          font-style: italic;
        }
      }
      .el-button {
        .set-font(@weight: 300,@size: 16px, @color: #fff);
        background-color: #000;
        background-color: rgba(0, 0, 0, .6);
        font-weight: 300;
        margin-top: 50px;
        margin-bottom: 5px;
        transition: background-color .3s;
        border: 0;
        border-radius: 0;
        width: 300px;
        text-align: center;
        &:hover {
          background-color: #000;
          background-color: rgba(0, 0, 0, .8);
          cursor: pointer;
        }
        &:focus {
          outline: 0
        }
      }
    }
    .registrati{
      margin-top: 15px !important;
      background-color: transparent !important;
      color: #000 !important;
      border: 1px solid #000 !important;
      &:hover{
        background-color: #d5dde5 !important;
      }
    }
    .errorLogin {
      .set-font(@weight: 300, @size: 14px, @color: #d20e0e);
      //display: block;
      height: 22px;
      text-align: center;
    }
    .recCred{
      text-align: center;
      font-size: 15px;
      color: #fff;
      cursor: pointer;
      span{
        border-bottom: 1px solid #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue